import * as yup from "yup";

export const preloginSchema = yup.object().shape({
  OrganizationID: yup.string().required("Organization ID is required!").trim(),
  UserName: yup.string().required("User Name is required!").trim(),
});
export const loginSchema = yup.object().shape({
  UserName: yup.string().required("User Name is required!").trim(),
  Password: yup.string().required("Password is required!").trim(),
});
export const changePasswordSchema = yup.object().shape({
  Password: yup.string(),
  NewPassword: yup
    .string()
    .required("Field is required!")
    .matches(
      /^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#%$&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.{8,30})/,
      "Use 8 or more characters with a mix of letters (upper and lower), numbers & symbols"
    ),
  ReEnterNewPassword: yup
    .string()
    .required("Field is required!")
    .oneOf([yup.ref("NewPassword"), null], "Passwords do not match."),
});
